// Окна `Modal` поверх друг друга: Escape закрывает только верхнее, Tab ходит по кругу
// внутри окна. Модуль без импортов — проверяется node:test (`modalStack.test.mjs`).

/** Открытые окна в порядке открытия. */
export interface ModalStack<T> {
  /** Положить окно наверх. Вернёт функцию, которая уберёт именно это окно. */
  push(item: T): () => void;
  /** Верхнее окно; `undefined`, если открытых нет. */
  top(): T | undefined;
  size(): number;
}

export function createModalStack<T>(): ModalStack<T> {
  const items: T[] = [];
  return {
    push(item) {
      items.push(item);
      return () => {
        const i = items.lastIndexOf(item);
        if (i >= 0) items.splice(i, 1);
      };
    },
    top: () => items[items.length - 1],
    size: () => items.length,
  };
}

/**
 * Куда перевести фокус по Tab, чтобы он не ушёл из окна. `count` — сколько в окне
 * элементов, до которых доходит Tab; `current` — номер элемента с фокусом среди них,
 * −1 — фокус на самом окне. `null` — браузер сам переведёт фокус куда нужно.
 */
export function nextFocusIndex(count: number, current: number, backwards: boolean): number | null {
  if (count === 0) return null;
  if (backwards) return current <= 0 ? count - 1 : null;
  return current >= count - 1 ? 0 : null;
}
